import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jsmCustomerAuthenticationSettingsResource } from '@atlassian/jira-router-resources-jsm-authentication-settings/src/services/index.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { productsJsmAuthenticationSettingsRoute } from '@atlassian/jira-router-routes-admin-pages-jsm-authentication-settings-routes/src/productsJsmAuthenticationSettingsRoute.tsx';
import AuthenticationSettings, {
	LazyAuthenticationSettings,
} from './ui/spa/admin-pages/jsm-authentication-settings/ui/index.tsx';

export const productsJsmAuthenticationSettingsRouteEntry = createEntry(
	productsJsmAuthenticationSettingsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-authentication-settings',
		component: AuthenticationSettings,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SIDEBAR_ID.GLOBAL_PRODUCTS_SETTINGS,
			menuId: MENU_ID.SETTINGS,
			sidebar: AsyncSidebarGlobalSettingsProducts,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			jsmCustomerAuthenticationSettingsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyAuthenticationSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-admin-pages-jsm-authentication-settings-entries/src/productsJsmAuthenticationSettingsRouteEntry.tsx',
				whichExportToUse: 'productsJsmAuthenticationSettingsRouteEntry',
			},

			enabled: true,
		},
	}),
);
